import type CK from '~/types/contentking';

import {
	useAccountLogoUrlQuery,
} from './useAccountLogoUrl.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



function useAccountLogoUrl(accountId: CK.AccountId | null) {
	const { data } = useAccountPropertiesQuery(
		useAccountLogoUrlQuery,
		accountId,
	);

	return data?.account?.logoUrl ?? null;
}



export default useAccountLogoUrl;
